<!-- Lista -->
<div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <h5 class="card-title mb-0">
      <i class="fas fa-list me-2"></i>
      Contatos Filtrados
      @if (data && data.paginacao) {
        <span class="text-muted">({{ data.paginacao.totalDeItens }})</span>
      }
    </h5>
  </div>
  <div class="card-body p-0">
    @if (isLoading) {
      <div class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Carregando...</span>
        </div>
        <p class="mt-2 text-muted">Carregando contatos...</p>
      </div>
    } @else {
      @if (!data || !data.contatos || data.contatos.length === 0) {
        <div class="text-center py-5">
          <i class="fas fa-users fa-3x text-muted mb-3"></i>
          <h5 class="text-muted mb-0">Nenhum contato encontrado</h5>
        </div>
      } @else {
        <div class="table-responsive">
          <table class="table table-hover table-striped mb-0">
            <thead class="table-light">
              <tr>
                <th class="px-3 py-2">Nome</th>
                <th class="px-3 py-2">Contato</th>
                <th class="px-3 py-2">Email</th>
              </tr>
            </thead>
            <tbody>
              @for (row of data.contatos; track $index) {
                <tr>
                  <td class="px-3 py-2">{{ row.nome }}</td>
                  <td class="px-3 py-2">{{ row.contato }}</td>
                  <td class="px-3 py-2">{{ row.email }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    }

    <!-- Paginação -->
    @if (!isLoading && data && data.paginacao && data.paginacao.totalDeItens > 0) {
      <div class="card-footer">
        <div class="row">
          <div class="col-sm-12 col-md-5">
            <div class="dataTables_info" role="status" aria-live="polite">
              Mostrando {{ (data.paginacao.paginaAtual - 1) * data.paginacao.quantidadePorPagina + 1 }} até
              {{ (data.paginacao.paginaAtual * data.paginacao.quantidadePorPagina) > data.paginacao.totalDeItens ? data.paginacao.totalDeItens : (data.paginacao.paginaAtual * data.paginacao.quantidadePorPagina) }} de
              {{ data.paginacao.totalDeItens }} registros
            </div>
          </div>
          <div class="col-sm-12 col-md-7">
            <div class="dataTables_paginate paging_simple_numbers d-flex justify-content-end">
              <ngb-pagination
                [page]="data.paginacao.paginaAtual"
                [pageSize]="data.paginacao.quantidadePorPagina"
                [collectionSize]="data.paginacao.totalDeItens"
                [maxSize]="5"
                [rotate]="true"
                [boundaryLinks]="true"
                (pageChange)="onChangePage($event)"
                class="pagination-rounded justify-content-end">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
